(function () {
    'use strict';

    angular.module('app.messageTemplates', [
        'ngRoute',
        'treeControl'
    ]);
})();